import API from "./api";

// ===== CATEGORIES =====

// get all categories
export const getCategories = async () => {
  const res = await API.get("/categories");
  return res.data;
};

// get single category
export const getCategory = async (id) => {
  const res = await API.get(`/categories/${id}`);
  return res.data;
};

// create category
export const createCategory = async (data) => {
  const res = await API.post("/categories", data);
  return res.data;
};

// update category
export const updateCategory = async (id, data) => {
  const res = await API.put(`/categories/${id}`, data);
  return res.data;
};

// delete category
export const deleteCategory = async (id) => {
  const res = await API.delete(`/categories/${id}`);
  return res.data;
};